import { Link } from 'react-router-dom';
import { Shield, ArrowRight, CheckCircle } from '@phosphor-icons/react';
import { PublicLayout } from '../components/layout/PublicLayout';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { portalRoutes } from '../lib/portalRoutes';
import { getPortalDesignBootstrap } from '../lib/portalDesignBootstrap';

export default function Login() {
  const bootstrap = window.portalReactBootstrap?.login ?? {};
  const portalDesign = getPortalDesignBootstrap();
  const loginError = typeof bootstrap.error === 'string' && bootstrap.error.trim() !== ''
    ? bootstrap.error.replace('Invalid credentials.', 'E-Mail oder Passwort sind nicht korrekt.')
    : '';
  const hasLoginError = loginError !== '';

  return (
    <PublicLayout
      eyebrow="Händlerbereich"
      title="Im Händler-Portal anmelden"
      description="Zugang zu Ihrem professionellen File-Service-System mit vergünstigten Preisen, schneller Bearbeitung und persönlichem Support."
      footer={`${portalDesign.portalName} Händlerbereich für Upload, Download und Auftragsverwaltung.`}
    >
      <form method="post" action={portalRoutes.login} className="space-y-6">
        <input type="hidden" name="_csrf_token" value={bootstrap.csrfToken || ''} />

        <div className="space-y-2">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-sm bg-primary/15 text-primary">
              <Shield className="h-6 w-6" weight="fill" />
            </div>
            <div>
              <h2 className="font-heading text-2xl font-bold">Anmelden</h2>
              <p className="text-sm text-muted-foreground">Original-Files hochladen, Aufträge verwalten und fertige Tuning-Files abrufen.</p>
            </div>
          </div>
        </div>

        <div className="grid gap-2 rounded-sm border border-border bg-secondary/35 p-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <CheckCircle weight="fill" className="h-4 w-4 text-primary" />
            Vergünstigte Händlerkonditionen
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle weight="fill" className="h-4 w-4 text-primary" />
            Tuning-Files in 30-60 Minuten
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle weight="fill" className="h-4 w-4 text-primary" />
            Persönlicher Support für Ihren Betrieb
          </div>
        </div>

        {hasLoginError ? (
          <div className="rounded-sm border border-red-500/40 bg-red-500/12 px-4 py-3 text-sm text-red-100 shadow-[0_0_0_1px_rgba(239,68,68,0.08)]" data-testid="login-error" role="alert" aria-live="polite">
            <div className="font-semibold text-red-200">Anmeldung fehlgeschlagen</div>
            <div className="mt-1">{loginError}</div>
          </div>
        ) : null}

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">E-Mail</Label>
            <Input id="email" name="email" type="email" defaultValue={bootstrap.lastUsername || ''} placeholder="kunde@beispiel.de" autoComplete="email" required aria-invalid={hasLoginError} className={hasLoginError ? 'border-red-500/60 bg-red-500/10 focus-visible:ring-red-500/60' : 'bg-secondary border-border'} data-testid="login-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Passwort</Label>
            <Input id="password" name="password" type="password" placeholder="••••••••" autoComplete="current-password" required aria-invalid={hasLoginError} className={hasLoginError ? 'border-red-500/60 bg-red-500/10 focus-visible:ring-red-500/60' : 'bg-secondary border-border'} data-testid="login-password" />
          </div>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row">
          <Button className="btn-gradient text-white sm:flex-1" type="submit" data-testid="login-submit">
            Zum Händler-Portal
            <ArrowRight className="ml-2 h-4 w-4" weight="bold" />
          </Button>
          <Button asChild variant="outline" className="border-border hover:bg-secondary sm:flex-1">
            <Link to={portalRoutes.register}>Zugang anfragen</Link>
          </Button>
        </div>

        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <Link to={portalRoutes.passwordResetRequest} className="hover:text-foreground">
            Passwort vergessen?
          </Link>
          <span>B2B Login für Händler und File-Service Partner.</span>
        </div>
      </form>
    </PublicLayout>
  );
}
